import { StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import { Dispatch, SetStateAction } from "react";
import CustomText from "../../general/CustomText/CustomText";
import CustomDropdown from "../../general/CustomDropDown/CustomDropdown";

interface SortingDropdownProps {
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<string>>;
  sortDropdownOpen: boolean;
  setSortDropdownOpen: Dispatch<SetStateAction<boolean>>;
  sortItems: { label: string; value: string }[];
  label?: string;
  customStyle?: StyleProp<ViewStyle>;
  fullWidth?: boolean;
  accessibilityLabel?: string;
}
const SortingDropdown = ({
  sortBy,
  setSortBy,
  sortDropdownOpen,
  setSortDropdownOpen,
  sortItems,
  label,
  customStyle,
  fullWidth = false,
  accessibilityLabel,
}: SortingDropdownProps) => {
  return (
    <View style={styles.sortByContainer} id={`${label || "dropdown"}-dropdown`}>
      {label && (
        <CustomText
          size="s"
          weight="normal"
          style={[{ display: "flex", color: "#667085", minWidth: 50 }, customStyle]}
          text={label}
        />
      )}
      <CustomDropdown
        accessibilityLabel={accessibilityLabel}
        options={sortItems}
        value={sortBy}
        onChange={(value) => {
          setSortBy(value);
          setSortDropdownOpen(false);
        }}
        open={sortDropdownOpen}
        onOpenChange={setSortDropdownOpen}
        fullWidth={fullWidth}
        dropdownContainerStyle={styles.dropdownContainer}
        dropdownStyle={styles.dropdownField}
      />
    </View>
  );
};

export default SortingDropdown;

const styles = StyleSheet.create({
  sortByContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 8,
    zIndex: 3000,
    elevation: 3000,
  },
  dropdownContainer: {
    borderColor: "rgb(229, 231, 235)",
    backgroundColor: "white",
    zIndex: 3000,
    elevation: 3000,
  },
  dropdownField: {
    borderColor: "rgb(229, 231, 235)",
    zIndex: 3000,
    elevation: 3000,
    minHeight: 42.5,
    backgroundColor: "white",
    borderRadius: 6,
    borderWidth: 1,
  },
});
